import { useCallback } from 'react';
import ChapterBadge from '@/components/ui/ChapterBadge/ChapterBadge';
import type { ChapterMeta } from '@/lib/chapters';
import { scrollToId } from '@/lib/scroll';
import styles from './ChapterNav.module.css';

type Props = {
  chapters: readonly ChapterMeta[];
  activeId: string | null;
};

export default function ChapterNav({ chapters, activeId }: Props) {
  const handleJump = useCallback((id: string) => {
    scrollToId(id);
  }, []);

  return (
    <nav className={styles.nav} aria-label="章ナビゲーション">
      <div className={styles.label}>章を選ぶ</div>
      <ul className={styles.list}>
        {chapters.map((c, index) => {
          const isActive = activeId === c.id;
          return (
            <li key={c.id}>
              <button
                type="button"
                className={`${styles.item} ${isActive ? styles.active : ''}`}
                onClick={() => handleJump(c.id)}
                aria-current={isActive ? 'true' : undefined}
              >
                <ChapterBadge number={index + 1} active={isActive} size="sm" />
                <span className={styles.title}>{c.shortTitle}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
